// extracted by mini-css-extract-plugin
export default {"visible":"navbar_visible__ojm77","hidden":"navbar_hidden__Nwj2I"};